<template>
  <div>
    <label class="text-left block" :for="id">
      <slot></slot>
    </label>
    <Input 
      class="w-full rounded-md !shadow w-full border-gray-300"
      :id="id"
      :type="type" 
      v-model="model" 
      :mask="mask"
      @blur="$emit('blur', $event); blurEvent()" 
      :disabled="disabled" 
      :value="value" 
      :min="min"
      :max="max"
      :required="required" 
      :placeholder="placeholder">
    </Input>
    <InputError
      :label="errorLabel" 
      :condition="errorCondition && required && edited"
    />
  </div>
</template>


<script>
import Input from '../Input.vue'
import InputError from './InputError.vue'

export default {
  props: {
    type: String,
    disabled: Boolean,
    value: String,
    mask: String,
    min: String,
    max: String,
    required: Boolean,
    placeholder: String,
    errorLabel: String,
    errorCondition: Boolean,
    id: String,
  },
  components: {
    Input,
    InputError
  },
  data() {
    return {
      edited: false,
    };
  },
  methods: {
    blurEvent(){
      this.edited = true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>